import React, {FC, ReactElement, useMemo} from "react";
import {IconButton, Tooltip as MuiTooltip, Typography} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import {OverridableStringUnion} from "@mui/types";
import {IconButtonPropsSizeOverrides} from "@mui/material/IconButton/IconButton";
import {TypographyProps, TypographyPropsVariantOverrides} from "@mui/material/Typography/Typography";
import {TooltipProps} from "@mui/material/Tooltip/Tooltip";
import {Variant} from "@mui/material/styles/createTypography";

interface Props extends Omit<TooltipProps, "title" | "children"> {
    iconSize?: OverridableStringUnion<'small' | 'medium' | 'large', IconButtonPropsSizeOverrides>
    children: NonNullable<React.ReactNode>
    variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>
    typography?: Omit<TypographyProps, "variant">
}

export const Tooltip: FC<Props> = ({iconSize = "small", typography, variant, children, ...tooltipProps}): ReactElement => {

    const newTooltipProps = useMemo(() => {
        if (typography || variant) {
            return {...tooltipProps, title: <Typography variant={variant} {...typography}>{children}</Typography>}
        } else {
            return {...tooltipProps, title: children};
        }
    }, [tooltipProps, typography, variant, children])

    return <MuiTooltip {...newTooltipProps}>
        <IconButton size={iconSize}><InfoIcon/><Typography></Typography></IconButton>
    </MuiTooltip>
};

export default Tooltip;